/* eslint-disable react/prop-types */
// Copyright (c) 2019 Deere & Company

import './header.scss';
import React from 'react';

const AccordionHeader = ({
    onClick, title, updateSequenceContents, isExpanded, secondaryNode,
    handleupdateSequenceContent, addAccordianContents, handleaddAccordianContent,
}) => (
    <div className="accordion-header">
        <div
            className="primary-content"
            onClick={onClick}
        >
            <div className="accordion-controls">
                <span className="accordion-icon" />
            </div>
            <div className="accordion-title">{title}</div>
        </div>
        {updateSequenceContents && isExpanded && (
            <div className="add-unsorted-icon" onClick={handleupdateSequenceContent} />
        )}
        {addAccordianContents && (
            <div className="add-icon" onClick={handleaddAccordianContent} />
        )}
        {isExpanded && <div className="secondary-content">{secondaryNode}</div>}
    </div>
);

AccordionHeader.displayName = 'AccordionHeader';

export default AccordionHeader;
